import { GetterTree, MutationTree, ActionTree, Module } from "vuex";
import { RootState } from "..";
import { Application } from "@/core/_models/application.model";
import Vue from "vue";

class ApplicationsState {
  items: Application[] | undefined = undefined;
}

export const state: ApplicationsState = {
  items: undefined
};

const namespaced: boolean | undefined = true;

const getters = {
  items(state) {
    if (!state.items) return [];

    return state.items.sort((a, b) => (a.Index < b.Index ? -1 : 1));
  },
  item:
    (state) =>
    (DatabaseId: string): Application | undefined => {
      if (!state.items) {
        return undefined;
      }

      const application = state.items.find((x) => x.DatabaseId == DatabaseId);

      return application;
    }
} as GetterTree<ApplicationsState, any>;

const mutations = {
  SET_APPLICATIONS(state, applications: Application[]) {
    state.items = applications;
  },
  UPDATE_APPLICATION(state, application: Application) {
    if (!state.items) return;

    const existingItem = state.items.findIndex((x) => x.DatabaseId === application.DatabaseId);

    if (existingItem !== -1) {
      Vue.set(state.items, existingItem, application);
    } else {
      state.items.push(application);
    }
  },
  REMOVE_APPLICATION(state, DatabaseId: string) {
    if (state.items != undefined) {
      state.items = state.items?.filter((x) => x.DatabaseId != DatabaseId);
    }
  }
} as MutationTree<ApplicationsState>;

const actions = {
  pushApplications({ commit, rootState }): any {
    const applications = rootState.applications.items;

    applications.forEach((application: Application) => {
      commit("UPDATE_APPLICATION", application);
    });
  }
} as ActionTree<ApplicationsState, any>;

export const applications: Module<ApplicationsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
